/* forbo-wic-ui.js - DEV 2026-10-17, unpublished theme only.
   rev 2026-10-23 FORBO-BATCH-1: selected tab scrolled into the tab row (N9),
   #forbo-project-questions opens the questions (guard link), gate message
   only once samples are in the tray (N14).
   Part 2 of 2. Painting, dialog, tabs, lazy images and event wiring.
   Requires forbo-wic-core.js to have run first (both deferred, document order).

   Every element it builds or reads uses a class the Wicanders stylesheet
   already defines (.wic-item__*, .wic-qty, .wic-dialog__*), so the tray rows
   and controls are the Wicanders ones rather than lookalikes.
*/
(function () {
  var W = window.ForboWic;
  if (!W || !W.root) return;

  var q = W.q, qa = W.qa;
  var tabs = qa('[data-wic-tab]');
  var panels = qa('[data-wic-panel]');
  var qtyInput = q('[data-wic-dlg-qty]');
  var alertEl = q('[data-wic-alert]');
  var current = null;
  var pendingQty = 0;

  /* Assertive counterpart to W.say(). W.say() writes a polite region, which
     queues behind whatever the screen reader is already reading - right for
     "Sample added", wrong for "you cannot check out yet". The region starts
     EMPTY in the markup so nothing is announced on load; it is only written
     when a shopper action is blocked. Clearing first makes a repeated identical
     message announce again, which a plain reassignment does not guarantee. */
  function alertNow(msg) {
    if (!alertEl || !msg) return;
    alertEl.textContent = '';
    window.setTimeout(function () { alertEl.textContent = msg; }, 60);
  }
  function activeTab() {
    return tabs.filter(function (t) {
      return t.getAttribute('aria-selected') === 'true';
    })[0] || tabs[0] || null;
  }

  /* -------------------------------- status -------------------------------- */
  W.paintStatus = function () {
    var miss = W.missingRequired();
    var ok = miss.length === 0;

    W.statusEls.forEach(function (el) {
      el.textContent = ok ? 'Complete' : miss.length + ' answer' + (miss.length > 1 ? 's' : '') + ' needed';
      el.className = 'wic-status ' + (ok ? 'wic-status--done' : 'wic-status--todo');
    });
    /* The gate sentence only means something once a sample is in the tray;
       on an empty tray it read as an error before the shopper had done
       anything (N14). The status chip still counts the answers needed. */
    if (W.gateEl) W.gateEl.hidden = ok || !W.sampleLines().length;
    if (W.checkoutEl) {
      /* NOT aria-disabled. This control stays operable on purpose - the click
         handler is what reveals the reason and moves focus to the question -
         so announcing it as unavailable would be false, and it also makes the
         button unclickable to assistive tech and to automation. The blocked
         state is conveyed instead by pointing the button's description at the
         visible gate sentence, which carries the reason; aria-describedby to a
         hidden target is ignored, so the description appears exactly when the
         message does.                                                        */
      if (ok) W.checkoutEl.removeAttribute('aria-describedby');
      else W.checkoutEl.setAttribute('aria-describedby', 'forbo-gate-msg');
      W.checkoutEl.classList.toggle('wic-btn--blocked', !ok);
    }
    var bs = q('[data-wic-bar-status]');
    if (bs) {
      bs.textContent = ok ? 'Project info complete' : 'Project info needed';
      bs.setAttribute('data-ok', ok ? '1' : '0');
    }
    W.fields.forEach(function (f) {
      var ta = f.querySelector('textarea');
      var need = f.getAttribute('data-required') === '1' && (!ta || !String(ta.value || '').trim());
      f.classList.toggle('wic-field--missing', need);
      /* aria-invalid is the programmatic half of .wic-field--missing, which only
         draws an orange border a screen reader cannot see. It clears itself as
         soon as an answer is typed, because every input event repaints. */
      if (ta) ta.setAttribute('aria-invalid', need ? 'true' : 'false');
    });
  };

  /* ------------------------------- tray rows ------------------------------- */
  function thumb(url) {
    if (!url) return '';
    return url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=112';
  }
  function el(tag, cls, text) {
    var n = document.createElement(tag);
    if (cls) n.className = cls;
    if (text !== undefined) n.textContent = text;
    return n;
  }
  /* A Forbo sample variant_title is "Sample / 3732 Asteroid" - the Size option
     comes first and the colour last, so the raw title is not a usable name. The
     tile already holds the colour the section resolved server-side, so reuse it;
     fall back to the last option value for a line added from another page. */
  function displayName(line) {
    var t = q('[data-wic-tile][data-variant="' + line.variant_id + '"]');
    if (t && t.getAttribute('data-short')) return t.getAttribute('data-short');
    var o = line.options_with_values;
    if (o && o.length) return o[o.length - 1].value;
    return line.variant_title || line.product_title;
  }
  function itemRow(line) {
    var name = displayName(line);
    var li = document.createElement('li');
    var item = el('div', 'wic-item');

    var img = el('img', 'wic-item__thumb');
    img.width = 56; img.height = 42; img.alt = ''; img.loading = 'lazy';
    img.src = thumb(line.image);

    var main = el('div', 'wic-item__main');
    var top = el('div', 'wic-item__top');
    top.appendChild(el('span', 'wic-chip wic-item__chip', W.LINE_NAME[String(line.product_id)] || ''));
    top.appendChild(el('span', 'wic-item__name', name));
    main.appendChild(top);
    main.appendChild(el('span', 'wic-item__sku', line.sku || ''));

    var row = el('div', 'wic-item__row');
    var qty = el('div', 'wic-item__qty');
    var minus = el('button', null, '-');
    minus.type = 'button';
    minus.setAttribute('aria-label', 'Remove one ' + name);
    var n = el('span', null, String(line.quantity));
    var plus = el('button', null, '+');
    plus.type = 'button';
    plus.setAttribute('aria-label', 'Add one ' + name);
    if (W.MAX && line.quantity >= W.MAX) plus.disabled = true;
    qty.appendChild(minus); qty.appendChild(n); qty.appendChild(plus);

    var rm = el('button', 'wic-item__rm', 'Remove');
    rm.type = 'button';
    /* Visible text "Remove" is enough beside the row, but a screen reader reads
       the controls out of context - four samples gave four identical "Remove"
       buttons. Name the sample, matching the two quantity buttons above. */
    rm.setAttribute('aria-label', 'Remove ' + name);

    /* By line KEY, never by index: indexes shift as lines are removed. */
    minus.addEventListener('click', function () { W.setLine(line.key, Math.max(0, line.quantity - 1)); });
    plus.addEventListener('click', function () { W.setLine(line.key, line.quantity + 1); });
    rm.addEventListener('click', function () {
      W.setLine(line.key, 0);
      W.say(name + ' removed.');
    });

    row.appendChild(qty);
    row.appendChild(el('span', 'wic-item__price', W.money(line.line_price)));
    row.appendChild(rm);
    main.appendChild(row);

    item.appendChild(img); item.appendChild(main);
    li.appendChild(item);
    return li;
  }

  /* -------------------------------- painting -------------------------------- */
  W.paint = function () {
    var lines = W.sampleLines();
    var count = lines.reduce(function (a, i) { return a + i.quantity; }, 0);
    var subtotal = lines.reduce(function (a, i) { return a + i.line_price; }, 0);

    qa('[data-wic-count]').forEach(function (e) { e.textContent = count; });
    qa('[data-wic-open-cart-n]').forEach(function (e) { e.textContent = count; });
    qa('[data-wic-bar-count]').forEach(function (e) { e.textContent = count; });

    var empty = q('[data-wic-empty]');
    if (empty) empty.hidden = count > 0;

    var items = q('[data-wic-items]');
    if (items) {
      items.textContent = '';
      lines.forEach(function (l) { items.appendChild(itemRow(l)); });
    }
    var sub = q('[data-wic-subtotal]');
    if (sub) sub.textContent = count ? W.money(subtotal) : '-';

    var other = q('[data-wic-other]');
    if (other) {
      var oc = W.otherCount();
      other.hidden = oc === 0;
      other.textContent = oc + ' other item' + (oc === 1 ? '' : 's') + ' already in your cart will stay there.';
    }

    qa('[data-wic-open-cart]').forEach(function (e) {
      if (e.closest('[data-wic-bar]')) return;
      e.hidden = count === 0;
    });
    if (W.bar) W.bar.hidden = count === 0;

    qa('[data-wic-tile]').forEach(function (t) {
      var c = q('[data-wic-tile-count]', t);
      var n = W.qtyOf(t.getAttribute('data-variant'));
      t.classList.toggle('is-selected', n > 0);
      if (c) { c.hidden = n === 0; c.textContent = n; }
    });

    if (current) paintDialogFor(current, true);
    /* The heading depends on the CART, not only the open tab, so it has to be
       re-resolved whenever the cart changes - not just on a tab switch. */
    applyQuizTitle(activeTab());
    W.paintStatus();
  };

  /* -------------------------------- dialog -------------------------------- */
  function paintDialogFor(tile, quiet) {
    var img = q('[data-wic-dlg-img]');
    if (img) {
      img.src = tile.getAttribute('data-image-large') || '';
      img.alt = tile.getAttribute('data-image-alt') || '';
      var w = parseInt(tile.getAttribute('data-image-w') || '0', 10);
      var h = parseInt(tile.getAttribute('data-image-h') || '0', 10);
      if (w && h) { img.width = w; img.height = h; }
    }
    var set = function (sel, val) { var e = q(sel); if (e) e.textContent = val; };
    set('[data-wic-dlg-chip]', W.LINE_NAME[tile.getAttribute('data-line-id')] || '');
    set('[data-wic-dlg-title]', tile.getAttribute('data-short') || '');
    set('[data-wic-dlg-full]', tile.getAttribute('data-fullname') || '');
    set('[data-wic-dlg-sku]', tile.getAttribute('data-sku') || '');
    set('[data-wic-dlg-price]', tile.getAttribute('data-price-formatted') || '');

    var avail = tile.getAttribute('data-available') === '1';
    var av = q('[data-wic-dlg-avail]');
    if (av) {
      av.textContent = avail ? 'In stock and ready to ship' : 'Currently unavailable';
      av.setAttribute('data-ok', avail ? '1' : '0');
    }

    var inCart = W.qtyOf(tile.getAttribute('data-variant'));
    if (!quiet) pendingQty = inCart > 0 ? inCart : 1;
    clampQty();

    var add = q('[data-wic-dlg-add]');
    if (add) {
      add.disabled = !avail;
      add.textContent = inCart > 0
        ? (pendingQty === 0 ? 'Remove this sample' : 'Update to ' + pendingQty)
        : 'Add this sample';
    }
    if (!quiet) W.note('');
  }
  /* Quantity 0 means "remove", which is only meaningful for a variant that has
     a cart line. For anything else the floor is 1, so a typed 0 or a stray "-"
     can never leave the add button as a silent no-op. */
  function clampQty() {
    var inCart = current ? W.qtyOf(current.getAttribute('data-variant')) : 0;
    var floor = inCart > 0 ? 0 : 1;
    if (isNaN(pendingQty)) pendingQty = floor;
    if (pendingQty < floor) pendingQty = floor;
    if (W.MAX && pendingQty > W.MAX) pendingQty = W.MAX;
    if (qtyInput) qtyInput.value = pendingQty;
  }
  function bumpQty(d) {
    pendingQty += d;
    clampQty();
    if (current) paintDialogFor(current, true);
  }
  function openFor(tile) {
    current = tile;
    if (W.dlg) W.dlg.removeAttribute('data-cartonly');
    paintDialogFor(tile, false);
    if (W.dlg && !W.dlg.open) W.dlg.showModal();
  }
  function openCartOnly() {
    current = null;
    if (W.dlg) {
      W.dlg.setAttribute('data-cartonly', '1');
      if (!W.dlg.open) W.dlg.showModal();
    }
    W.paint();
  }

  /* --------------------- tabs and per-line question wording --------------------- */

  /* The questionnaire wording belongs to a product LINE, and the cart can hold
     samples from more than one. Following the open tab alone retitles a
     Bulletin-Board-only cart "Marmoleum Sheet Samples & Quote Form" the moment
     the shopper looks at a Marmoleum tab - the heading then describes what is on
     screen rather than what is being ordered.

     Each tab already carries data-line-id (the product_id the section resolved),
     so a cart line maps back to its own tab with no markup change. Note the test
     is on the distinct TITLE, not on the collection: there are only two distinct
     titles across the twelve lines, so "more than one collection" would have
     thrown away a correct, specific heading for e.g. a Fresco + Terra cart,
     which is legitimately one wording. */
  function cartQuizTitles() {
    var seen = [];
    (W.sampleLines() || []).forEach(function (line) {
      var t = q('[data-wic-tab][data-line-id="' + line.product_id + '"]');
      var title = t && t.getAttribute('data-quiz-title');
      if (title && seen.indexOf(title) === -1) seen.push(title);
    });
    return seen;
  }
  function applyQuizTitle(tab) {
    if (!W.quizTitleEl) return;
    var inCart = cartQuizTitles();
    var title;
    if (inCart.length > 1) {
      title = W.quizTitleEl.getAttribute('data-quiz-title-mixed');
    } else if (inCart.length === 1) {
      title = inCart[0];            /* keeps Bulletin Board's own wording */
    } else {
      title = tab && tab.getAttribute('data-quiz-title');   /* empty cart */
    }
    if (title) W.quizTitleEl.textContent = title;
  }

  /* The questionnaire intro follows the TAB, not the cart, because it is
     instructional content about the line being looked at - the Marmoleum
     square-yard measuring instructions must not print on the Bulletin Board
     tab, which measures nothing by the square yard. (The TITLE is cart-aware
     instead, because it names the form the order carries; see applyQuizTitle.)
     Nodes are resolved on each call rather than cached at load, so this cannot
     depend on where in the file the dialog markup was parsed. */
  function applyQuizIntro(tab) {
    var lede = q('[data-wic-quiz-lede]');
    if (!lede) return;
    var html = (tab && tab.getAttribute('data-quiz-intro')) || '';
    if (!html) html = lede.getAttribute('data-lede-default') || '';
    if (lede.innerHTML !== html) lede.innerHTML = html;
    lede.hidden = !html;
  }

  /* Per-line breadcrumb parent, restored from the live template. Falls back to
     the section default held on the wrapper, so switching away from Bulletin
     Board does not leave its parent crumb behind. */
  function applyCrumb(tab) {
    var wrap = q('[data-wic-crumb-parent]');
    var link = q('[data-wic-crumb-link]');
    if (!wrap || !link) return;
    var url = (tab && tab.getAttribute('data-parent-url')) || wrap.getAttribute('data-default-url') || '';
    var title = (tab && tab.getAttribute('data-parent-title')) || wrap.getAttribute('data-default-title') || '';
    if (url && title) {
      link.setAttribute('href', url);
      link.textContent = title;
      wrap.hidden = false;
    } else {
      wrap.hidden = true;
    }
  }

  function applyWording(tab) {
    if (!tab) return;
    applyQuizTitle(tab);
    applyQuizIntro(tab);
    applyCrumb(tab);

    var map = { '1': 'data-q-sqft', '2': 'data-q-timing', '3': 'data-q-notes' };
    W.fields.forEach(function (f) {
      var src = map[f.getAttribute('data-n')];
      if (!src) return;
      var txt = tab.getAttribute(src);
      if (!txt) return;
      f.setAttribute('data-label', txt);
      var span = f.querySelector('[data-wic-qlabel]');
      if (span) span.textContent = txt;
    });
    /* Re-stamp the order note so it carries the wording now on screen. */
    if (W.anyAnswered()) W.pushQuestionnaire();
  }
  function selectTab(key, focus) {
    var active = null;
    tabs.forEach(function (t) {
      var on = t.getAttribute('data-wic-tab') === key;
      t.setAttribute('aria-selected', on ? 'true' : 'false');
      t.setAttribute('tabindex', on ? '0' : '-1');
      if (on) { active = t; if (focus) t.focus(); }
    });
    panels.forEach(function (p) { p.hidden = p.getAttribute('data-wic-panel') !== key; });
    applyWording(active);
    lazyScan();
    var nameEl = active ? active.querySelector('.wic-tab__name') : null;
    W.say((nameEl ? nameEl.textContent.trim() : key) + ' shown. Your selected samples are unchanged.');
  }

  /* ------------------------------ lazy images ------------------------------ */
  var io = null;
  function showImg(img) {
    if (img.getAttribute('data-done')) return;
    img.setAttribute('data-done', '1');
    if (img.getAttribute('data-srcset')) img.srcset = img.getAttribute('data-srcset');
    if (img.getAttribute('data-src')) img.src = img.getAttribute('data-src');
  }
  /* Only images in the VISIBLE panel are observed. With 225 variants across
     twelve panels this is what keeps the page from requesting every thumbnail
     at once; each panel is scanned the first time its tab is shown. */
  function lazyScan() {
    var imgs = qa('img[data-lazy]:not([data-done])').filter(function (i) { return !i.closest('[hidden]'); });
    if (!('IntersectionObserver' in window)) { imgs.forEach(showImg); return; }
    if (!io) {
      io = new IntersectionObserver(function (es) {
        es.forEach(function (e) {
          if (e.isIntersecting) { showImg(e.target); io.unobserve(e.target); }
        });
      }, { rootMargin: '400px 0px' });
    }
    imgs.forEach(function (i) { io.observe(i); });
  }

  /* -------------------------------- wiring -------------------------------- */
  tabs.forEach(function (t) {
    t.addEventListener('click', function () { selectTab(t.getAttribute('data-wic-tab')); });
    t.addEventListener('keydown', function (e) {
      var i = tabs.indexOf(t), n = null;
      if (e.key === 'ArrowRight') n = tabs[(i + 1) % tabs.length];
      if (e.key === 'ArrowLeft') n = tabs[(i - 1 + tabs.length) % tabs.length];
      if (e.key === 'Home') n = tabs[0];
      if (e.key === 'End') n = tabs[tabs.length - 1];
      if (n) { e.preventDefault(); selectTab(n.getAttribute('data-wic-tab'), true); }
    });
  });

  qa('[data-wic-tile]').forEach(function (t) {
    t.addEventListener('click', function () { openFor(t); });
  });
  qa('[data-wic-open-cart]').forEach(function (e) { e.addEventListener('click', openCartOnly); });
  qa('[data-wic-dlg-back]').forEach(function (e) {
    e.addEventListener('click', function () { if (W.dlg && W.dlg.open) W.dlg.close(); });
  });

  var minusB = q('[data-wic-dlg-minus]'), plusB = q('[data-wic-dlg-plus]'), addB = q('[data-wic-dlg-add]');
  if (minusB) minusB.addEventListener('click', function () { bumpQty(-1); });
  if (plusB) plusB.addEventListener('click', function () { bumpQty(1); });
  if (qtyInput) {
    qtyInput.addEventListener('change', function () {
      pendingQty = parseInt(qtyInput.value, 10);
      clampQty();
      if (current) paintDialogFor(current, true);
    });
  }

  if (addB) addB.addEventListener('click', function () {
    if (!current) return;
    var vid = current.getAttribute('data-variant');
    var short = current.getAttribute('data-short') || 'Sample';
    var existing = W.lineFor(vid);

    if (pendingQty === 0) {
      if (existing) {
        W.setLine(existing.key, 0);
        W.note('Removed.');
        W.say(short + ' removed.');
      }
      return;
    }
    if (existing) {
      W.setLine(existing.key, pendingQty).then(function () {
        W.note('Updated to ' + pendingQty + '.');
        W.say(short + ' updated to ' + pendingQty + '.');
      });
      return;
    }
    W.addSample(vid, pendingQty).then(function () {
      W.note('Added. Choose more, or review your samples.');
      W.say(short + ' added.');
    });
  });

  W.fields.forEach(function (f) {
    var ta = f.querySelector('textarea');
    if (!ta) return;
    ta.addEventListener('input', W.pushQuestionnaire);
    ta.addEventListener('blur', W.pushQuestionnaire);
  });

  /* The gate. Keeps the shopper inside the window: the questions are in the
     tray, so the first missing field is focused exactly where it already is -
     no closing the dialog and scrolling up, which is what the live page does. */
  if (W.checkoutEl) {
    W.checkoutEl.setAttribute('href', W.CART_URL);
    W.checkoutEl.addEventListener('click', function (e) {
      var miss = W.missingRequired();
      if (!miss.length) return;
      e.preventDefault();
      if (W.gateEl) { W.gateEl.hidden = false; W.gateEl.textContent = W.GATE_MSG; }
      if (W.dlg && !W.dlg.open) openCartOnly();
      if (miss[0].ta) {
        miss[0].ta.focus();
        /* Scroll the FIELD, not the textarea, and align its top. Centring the
           textarea in a short scrollport pushes its own label out of view:
           measured at 1280x720 the input was fully visible while the label
           showed 14 of 38px, and at 1366x650 the label was gone entirely -
           the shopper is dropped into an unlabelled box. Aligning the labelled
           wrapper to the top of the quiz region shows the question, the
           (required) marker and the input together.                          */
        var fw = miss[0].ta.closest('[data-wic-field]') || miss[0].ta;
        fw.scrollIntoView({ block: 'start', behavior: 'smooth' });
      }
      W.say(W.GATE_MSG);
      /* The polite region above can queue behind whatever is being read, and
         the reason alone ("answer the questions") does not say WHICH. Name the
         outstanding questions assertively, from their on-screen labels, so the
         announcement matches what the shopper is now focused on. */
      alertNow(W.GATE_MSG + ' ' + miss.map(function (m) {
        var f = m.ta && m.ta.closest('[data-wic-field]');
        var s = f && f.querySelector('[data-wic-qlabel]');
        return s ? s.textContent.trim() : '';
      }).filter(Boolean).join('; '));
    });
  }

  /* The server opens the tab for this page's own collection, but on a phone
     the tab row scrolls sideways and a late tab (Terra) starts ~2,000px off
     screen. Scroll the row only - never the page - so the shopper lands where
     they were and still sees their collection selected (N9). */
  function revealActiveTab() {
    var t = activeTab();
    var list = t && t.parentNode;
    if (!list || list.scrollWidth <= list.clientWidth) return;
    var left = t.offsetLeft - list.offsetLeft - (list.clientWidth - t.offsetWidth) / 2;
    list.scrollLeft = Math.max(0, left);
  }
  revealActiveTab();

  /* The sitewide checkout guard links here with #forbo-project-questions.
     The questions live inside the samples window, which a plain anchor cannot
     open, so open the window and focus the first unanswered required one. */
  function openQuestionsFromHash() {
    if (window.location.hash !== '#forbo-project-questions') return;
    if (!W.sampleLines().length) return;
    openCartOnly();
    var miss = W.missingRequired();
    var ta = miss.length ? miss[0].ta : null;
    var wrap = ta && ta.closest('[data-wic-field]');
    /* Same target and options as the checkout click handler: centring the
       textarea hid its label, so the field wrapper is scrolled to the top. */
    if (ta) window.setTimeout(function () {
      ta.focus({ preventScroll: true });
      if (wrap && wrap.scrollIntoView) wrap.scrollIntoView({ block: 'start', behavior: 'smooth' });
    }, 80);
  }
  /* The guard banner in the cart drawer links to this same page plus the
     hash, which changes the hash without a reload; a click when the hash is
     already set changes nothing, so the banner click is caught as well. */
  window.addEventListener('hashchange', openQuestionsFromHash);
  document.addEventListener('click', function (e) {
    var a = e.target && e.target.closest && e.target.closest('a[href*="#forbo-project-questions"]');
    if (!a || window.location.hash !== '#forbo-project-questions') return;
    if (a.pathname !== window.location.pathname) return;
    e.preventDefault();
    openQuestionsFromHash();
  });

  document.addEventListener('cart:refresh', function () {
    W.getCart().then(function (c) { W.cart = c; W.paint(); });
  });

  W.getCart().then(function (c) {
    W.cart = c;
    W.hydrateFromCart();
    W.paint();
    lazyScan();
    applyWording(tabs.filter(function (t) {
      return t.getAttribute('aria-selected') === 'true';
    })[0] || tabs[0]);
    openQuestionsFromHash();
  }).catch(function () {
    W.paint();
    lazyScan();
  });
})();